const STATUS_FLAG_FIELD = {
  IS_VALIDATED: 'isValidated',
  IS_TIER_ONE_DONE: 'isTierOneDone',
  IS_CURATION_DONE: 'isCurationDone',
  IS_QA_DONE: 'isQaDone',
  IS_QC_DONE: 'isQcDone',
  IS_PUBLISHED: 'isPublished',
}

export default STATUS_FLAG_FIELD
